module.exports = __webpack_public_path__ + "static/media/insta-icon.4405cbcb.svg";